var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-center",class:_vm.classes},[_c('span',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" All rights reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }